module.exports = __webpack_public_path__ + "img/fe0fed00-aa7e-4513-9787-6a50c55b1be5.a52a7c6f.png";